module.exports = __webpack_public_path__ + "static/img/社区bg@2x.1adc3277.png";